import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPackageRemove"><Path d="M8 3H3V21H13.5148L12.136 19.6213L14.2574 17.4999L12.136 15.3786L16.3787 11.136L18.5 13.2573L21 10.7573V3H16V9H8V3Z" fill="currentColor"/><Path d="M14 3H10V7H14V3Z" fill="currentColor"/><Path d="M19.9142 17.5L22.0355 15.3787L20.6213 13.9645L18.5 16.0858L16.3787 13.9645L14.9645 15.3787L17.0858 17.5L14.9645 19.6213L16.3787 21.0355L18.5 18.9142L20.6213 21.0355L22.0355 19.6213L19.9142 17.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPackageRemove;
